import { Component } from '@angular/core';

@Component({
  selector: 'app-not-allow',
  templateUrl: './not-allow.component.html',
  styleUrl: './not-allow.component.scss',
})
export class NotAllowComponent {}
